var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7 15.9467C12.56 15.1934 14.6667 12.5934 14.6667 9.50006C14.6667 5.82006 11.7067 2.83339 8 2.83339C3.55334 2.83339 1.33334 6.54006 1.33334 6.54006M1.33334 6.54006V3.50006M1.33334 6.54006H2.67334H4.29334",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 9.50006C1.33334 13.1801 4.32 16.1667 8 16.1667",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.78e3ffa1b81b892c9ac49e4f3acb23e7.svg";
export { ForwardRef as ReactComponent };